import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Card,
  Grid,
  MenuItem,
} from "@material-ui/core";
import {
  ValidatorForm,
  SelectValidator,
  TextValidator,
} from "react-material-ui-form-validator";

import { useForm } from "../../../../hooks/useForm";
import { ESTADO_SOLICITUD_ADICCIONES, STEPPER_ADICCIONES } from "../../data/constants";
import {
  generatePdfPorIdSolicitudAdicciones,
  //getFormularioCud,
  getTiposSolicitudesAdicciones,
  postSolicitudAdicciones,
  putCancelarSolicitudAdicciones,
  setActiveStepAdicciones,
  setSolicitudAdicciones
} from "../../../../actions/adicciones/adiccionesActions";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import ValidatedDatePicker from "../../../compartidos/ValidatedDatePicker";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es";
import { startAlerta } from "../../../../actions/ui/alertas";
import { fetchCertificados } from "../../../../actions/certificados";
import { AlertFinalizadoStepper } from "../../../stepper/AlertFinalizadoStepper";
import { TableToolbarExportAndPrint } from "../../../turnos/recepcionDiaria/TableToolbarExportAndPrint";
import { ADICCIONES_PERMISOS } from '../../../../utils/permisos';
import { validarSoloUnPermiso } from '../../../../helpers/permisos';
import { AutoCompleteEfectorFacturacionAdic } from "../../UI/AutoCompleteEfectorFacturacionAdic";
// import { fetchLocalidades } from "../../../../actions/cbos/localidades";

export const AdiccionesDetalleOrdenElementos = (props) => {
  const dispatch = useDispatch();

  const {
    tiposSolicitudes = [],
    afiliadoSeleccionado = {},
    solicitudSeleccionada = {},
  } = useSelector((state) => state.adicciones);
  const { idSeccional, permisos: permisosUser, dni } = useSelector((state) => state.auth);

  const [confirmarCancelar, setConfirmarCancelar] = useState(false);
  const [openValidacionDni, setOpenValidacionDni] = useState(false);
  const [haveChangeValues, setHaveChangeValues] = useState(false);
  const [dniUser, setDniUser] = useState('');

  const disabled = props.disabled;

  let solicitudDefault = {
    idSolicitud: "",
    estadosSolicitud: "",
    fecha: "",
    fechaDesde: "",
    fechaHasta: "",
    idAfiliado: "",
    idDiagnostico: "",
    idEstadoSolicitud: "",
    idTipoSolicitud: "",
    idSubTipoSolicitud: "",
    idUsuario: "",
    tipoSolicitud: "",
    fechaIngresoLegajo: "",
    nombreTutor: "",
    emailTutor: "",
    celularTutor: ""
  };

  const [
    formValues,
    ,
    ,
    setearValor,
    ,
    ,
    ,
    ,
    setearVariosValores,
  ] = useForm(
    !!solicitudSeleccionada ? solicitudSeleccionada : solicitudDefault
  );

  const {
    fechaDesde,
    fechaHasta,
    idSolicitud,
    idTipoSolicitud,
    idSubTipoSolicitud,
    fechaIngresoLegajo,
    nombreTutor,
    emailTutor,
    celularTutor
  } = formValues;

  useEffect(() => {
    dispatch(getTiposSolicitudesAdicciones());
    if (afiliadoSeleccionado?.id_afiliado && !props.gestion) {
      dispatch(fetchCertificados(afiliadoSeleccionado?.id_afiliado));
      //dispatch(getFormularioCud(afiliadoSeleccionado?.id_afiliado, true));
    }
    if (props.gestion && solicitudSeleccionada?.afiliado?.id_afiliado) {
      dispatch(fetchCertificados(solicitudSeleccionada?.afiliado?.id_afiliado));
      //dispatch(getFormularioCud(solicitudSeleccionada?.afiliado?.id_afiliado, true));
    }
  }, [dispatch, afiliadoSeleccionado, props.gestion, solicitudSeleccionada]);

  const tipoVisible = false;

  const onSubmitHandler = () => {
    console.log("aca entro", !solicitudSeleccionada?.idEfectorFacturacion);

    if (!haveChangeValues) {
      dispatch(setActiveStepAdicciones(STEPPER_ADICCIONES.DIAGNOSTICO_DOCUMENTACION));
    } else {
      if (!solicitudSeleccionada?.idEfectorFacturacion) {
        dispatch(startAlerta("Debe seleccionar un Efector.", "error"));
      } else {
        const data = {
          ...solicitudSeleccionada,
          fechaDesde,
          fechaHasta,
          idAfiliado: !props.gestion
            ? afiliadoSeleccionado?.id_afiliado
            : solicitudSeleccionada?.afiliado?.id_afiliado,
          idEfectorFacturacion: solicitudSeleccionada?.idEfectorFacturacion,
          efectorFacturacion: solicitudSeleccionada?.efectorFacturacion,
          idSeccional,
          idSolicitud,
          idTipoSolicitud,
          idSubTipoSolicitud,
          fechaIngresoLegajo,
          nombreTutor,
          emailTutor,
          celularTutor
        };

        dispatch(setSolicitudAdicciones(data));
        dispatch(postSolicitudAdicciones(
          data,
          !props.gestion
            ?
            STEPPER_ADICCIONES.DIAGNOSTICO_DOCUMENTACION
            :
            null
        )
        );
      }
    }
  };

  //FechaDesde
  ValidatorForm.addValidationRule("isBeforeToday", (value) => {
    if (!moment(value).isValid() || moment(value).isBefore(moment(), "day")) {
      return false;
    }
    return true;
  });

  //FechaHasta
  ValidatorForm.addValidationRule("isAfterFechaDesde", (value) => {
    if (
      !moment(value).isValid() ||
      moment(value).isBefore(moment(fechaDesde), "day")
    ) {
      return false;
    }
    return true;
  });

  const handleGeneratePdf = () => {
    dispatch(generatePdfPorIdSolicitudAdicciones(idSolicitud));
  };

  const handleSendConfirmarCancelar = () => {
    if (Number(dni) !== Number(dniUser))
      return dispatch(startAlerta("El DNI ingresado no coincide con el del usuario logueado", "error"));

    dispatch(
      putCancelarSolicitudAdicciones(
        solicitudSeleccionada?.idSolicitud,
        props.onCloseModalAuditar,
        true
      )
    )
    resetValues();
  }

  const resetValues = () => {
    setDniUser('');
    setOpenValidacionDni(false);
    setConfirmarCancelar(false);
  }

  return (
    <ValidatorForm onSubmit={onSubmitHandler} style={{ margin: "1rem 3rem" }}>
      <Grid
        container
        spacing={2}
        style={{ display: "flex", justifyContent: "center" }}
      >
        {tipoVisible && <Grid item xs={12}>
          <SelectValidator
            fullWidth
            margin="normal"
            label="Tipo de Solicitud"
            name="idTipoSolicitud"
            value={idTipoSolicitud ?? ''}
            onChange={(e) => {
              setearVariosValores({
                idSubTipoSolicitud: '',
                idTipoSolicitud: e.target.value,
              });
              setHaveChangeValues(true);
            }}
            disabled={disabled}
            validators={["required"]}
            errorMessages={["Este campo es requerido"]}
          >
            {tiposSolicitudes.map((tipoSolicitud) => (
              <MenuItem
                key={tipoSolicitud.idTipo}
                value={tipoSolicitud.idTipo}
              >
                {tipoSolicitud.descripcion}
              </MenuItem>

            ))}
          </SelectValidator>
        </Grid>}
        <Grid item xs={4}>
          <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
            <ValidatedDatePicker
              fullWidth={true}
              margin="normal"
              format="dd/MM/yyyy"
              okLabel="Aceptar"
              clearLabel="Limpiar"
              cancelLabel="Cancelar"
              label="Fecha Desde"
              name="fechaDesde"
              value={
                fechaDesde !== undefined &&
                  moment(fechaDesde).isValid()
                  ? moment(fechaDesde)
                  : null
              }
              onChange={(e) => {
                setHaveChangeValues(true);
                setearValor("fechaDesde", e);
              }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              // minDate={new Date()}
              disabled={disabled}
              validators={disabled
                ?
                []
                :
                [
                  "required",
                  // "isBeforeToday",
                ]
              }
              errorMessages={
                [
                  "La fecha desde es requerida",
                  // "La fecha desde no puede ser menor a la fecha actual",
                ]
              }
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={4}>
          <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
            <ValidatedDatePicker
              fullWidth={true}
              margin="normal"
              format="dd/MM/yyyy"
              okLabel="Aceptar"
              clearLabel="Limpiar"
              cancelLabel="Cancelar"
              label="Fecha Hasta"
              name="fechaPrescripcion"
              value={
                fechaHasta !== undefined &&
                  moment(fechaHasta).isValid()
                  ? moment(fechaHasta)
                  : null
              }
              onChange={(e) => {
                setHaveChangeValues(true);
                setearValor("fechaHasta", e);
              }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              minDate={fechaDesde}
              disabled={disabled}
              validators={
                [
                  "required",
                  "isAfterFechaDesde",
                ]
              }
              errorMessages={
                [
                  "La fecha hasta es requerida",
                  "La fecha hasta no puede ser menor a la fecha desde",
                ]
              }
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={4}>
          <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
            <ValidatedDatePicker
              fullWidth={true}
              margin="normal"
              format="dd/MM/yyyy"
              okLabel="Aceptar"
              clearLabel="Limpiar"
              cancelLabel="Cancelar"
              label="Fecha Ingreso Legajo"
              name="fechaIngresoLegajo"
              value={
                fechaIngresoLegajo !== undefined &&
                  moment(fechaIngresoLegajo).isValid()
                  ? moment(fechaIngresoLegajo)
                  : null
              }
              onChange={(e) => {
                setHaveChangeValues(true);
                setearValor("fechaIngresoLegajo", e);
              }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              //minDate={new Date()}
              disabled={disabled}
              validators={disabled
                ?
                []
                :
                [
                  "required",
                ]
              }
              errorMessages={
                [
                  "La fecha de ingreso de legajo es requerida",
                ]
              }
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12}>
          <AutoCompleteEfectorFacturacionAdic integracion={true} disabled={disabled} />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextValidator
            //disabled
            fullWidth
            variant="outlined"
            margin="normal"
            label="Nombre Padre / Madre / Tutor"
            name="nombrePadreMadreTutor"
            value={nombreTutor ?? ""}
            onChange={(e) => {
              setHaveChangeValues(true);
              setearValor("nombreTutor", e.target.value);
            }}
            InputLabelProps={{ shrink: true, style: { fontWeight: 'bold' } }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextValidator
            //disabled
            fullWidth
            variant="outlined"
            margin="normal"
            label="Celular"
            name="celular"
            value={celularTutor ?? ""}
            onChange={(e) => {
              setHaveChangeValues(true);
              setearValor("celularTutor", e.target.value);
            }}
            InputLabelProps={{ shrink: true, style: { fontWeight: 'bold' } }}
          />
        </Grid>
        <Grid item xs={12} md={8}>
          <TextValidator
            //disabled
            fullWidth
            variant="outlined"
            margin="normal"
            label="Email"
            name="email"
            value={emailTutor ?? ""}
            onChange={(e) => {
              setHaveChangeValues(true);
              setearValor("emailTutor", e.target.value);
            }}
            InputLabelProps={{ shrink: true, style: { fontWeight: 'bold' } }}
          />
        </Grid>
        {(solicitudSeleccionada?.idEstadoSolicitud === ESTADO_SOLICITUD_ADICCIONES.RECHAZADA ||
          solicitudSeleccionada?.idEstadoSolicitud === ESTADO_SOLICITUD_ADICCIONES.AUDITORIA_ADMINISTRATIVA) &&
          solicitudSeleccionada?.notasSolicitud.length > 0 &&
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <Card
              style={{ backgroundColor: 'red', color: 'white', padding: 15, fontSize: 16 }}
            >
              <strong>{solicitudSeleccionada?.idEstadoSolicitud === ESTADO_SOLICITUD_ADICCIONES.RECHAZADA
                ? 'Motivo Rechazo'
                : 'Motivo Devolución'
              }: </strong>
              {solicitudSeleccionada?.notasSolicitud[solicitudSeleccionada?.notasSolicitud.length - 1].descripcion}
            </Card>
          </Grid>
        }
        {solicitudSeleccionada?.idEstadoSolicitud === ESTADO_SOLICITUD_ADICCIONES.AUTORIZADA &&
          !solicitudSeleccionada?.emailEnviadoPrestador &&
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <Card style={{ backgroundColor: 'grey', color: 'white', padding: 15, fontSize: 16 }}>
              <strong>Envio Email Prestador: </strong>FALLIDO, no tiene email cargado en el Contrato
            </Card>
          </Grid>
        }
      </Grid>
      {!props.gestion
        ?
        <div
          style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
        >
          <Button
            variant="contained"
            color="secondary"
            style={{ marginRight: "15rem" }}
            onClick={() => {
              dispatch(setActiveStepAdicciones(STEPPER_ADICCIONES.DATOS_AFILIADO));
            }}
          >
            Anterior
          </Button>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={(props.gestion && !haveChangeValues) || props.disabled}
          >
            Siguiente
          </Button>
        </div>
        :
        <div
          style={{
            margin: "1rem 0",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
          }}
        >
          {solicitudSeleccionada?.idEstadoSolicitud === ESTADO_SOLICITUD_ADICCIONES.AUTORIZADA &&
            <TableToolbarExportAndPrint
              cargada={true}
              // handleExportExcel={handleExportExcel}
              handleGeneratePdf={handleGeneratePdf}
            />
          }
          {solicitudSeleccionada?.idEstadoSolicitud === ESTADO_SOLICITUD_ADICCIONES.AUTORIZADA
            && validarSoloUnPermiso(permisosUser, ADICCIONES_PERMISOS.CANCELAR_SOLICITUD_ADICCIONES_AUTORIZADA) &&
            <>
              <AlertFinalizadoStepper
                open={confirmarCancelar}
                pregunta={"Cancelar Solicitud"}
                dialogText={`Esta seguro de cancelar la Solicitud?`}
                buttonCancel={"Cancelar"}
                buttonSubmit={"Confirmar"}
                handleClose={() => setConfirmarCancelar(false)}
                handleSend={() => setOpenValidacionDni(true)}
              />
              <AlertFinalizadoStepper
                open={openValidacionDni}
                pregunta={"Validación datos"}
                dialogText={`Ingrese el DNI del Usuario loqueado para confirmar la eliminación de la solicitud`}
                buttonCancel={"Cancelar"}
                buttonSubmit={"Confirmar"}
                showTextBox={true}
                textBoxValue={dniUser}
                setTextBoxValue={setDniUser}
                textBoxLabel={'Nro. Doc. Usuario'}
                handleClose={() => resetValues()}
                handleSend={() => handleSendConfirmarCancelar()}
              />
              <Button
                variant="contained"
                color="primary"
                style={{ marginLeft: '-25%' }}
                onClick={() => setConfirmarCancelar(true)}
              >
                Cancelar Autorizacion
              </Button>
            </>
          }
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={(props.gestion && !haveChangeValues) || props.disabled}
          >
            Guardar Cambios
          </Button>
        </div>
      }
    </ValidatorForm>
  );
};
